/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getUserSettings = ({ params } = {}) => axios.get(`user_settings`, { params });
